<template>
	<div>
		<NpAlert
			class="np-lookup__alert--success"
			type="success"
			ref="confirmRef"
			v-if="confirmationMessage"
		>
			<h4 class="np-text-sm">{{ confirmationMessage }}</h4>
		</NpAlert>
		<h1
			class="np-customer-lookup__title np-font-semibold np-mb-4 np-mt-0 np-text-gray-800 np-text-lg"
		>
			Look Up A Reservation
		</h1>
		<form @submit.prevent="onSubmit">
			<AppInput
				autocomplete="email"
				ref="email"
				v-model="email"
				:class="['np-form-group np-w-full']"
				label="Email"
				name="email"
				:required="true"
				type="email"
				v-validate="{ required: true, email: true }"
			/>
			<div style="text-align-last: right;">
				<button class="np-button np-button--primary" :disabled="!email" type="submit">
					Send Email
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import NpAlert from '@/components/NpAlert.vue';

export default {
	name: 'LookupForm',
	inject: ['$validator'],
	components: {
		NpAlert,
	},
	data() {
		return {
			email: '',
			confirmationMessage: null,
		};
	},

	methods: {
		...mapActions('reservation', ['sendLookupEmail']),

		async onSubmit() {
			if (!(await this.$validator.validateAll())) {
				return;
			}
			this.$store.dispatch('googleEvents/reservationLookup', {
				email: this.email,
			});
			this.sendLookupEmail(this.email).then((results) => {
				this.confirmationMessage = results;
				this.email = '';
				setTimeout(() => {
					this.$emit('close');
				}, 5000);
			});
		},
	},
};
</script>
